import cx, { type ClassValue } from "clsx";
import React, { type ButtonHTMLAttributes, type ReactNode } from "react";

export function LinkButton({
  className,
  children,
  type,
  ...otherProps
}: {
  className?: ClassValue;
  children?: ReactNode;
  type: NonNullable<ButtonHTMLAttributes<HTMLButtonElement>["type"]>
}) {
  return (
    <button
      {...otherProps}
      className={
        cx(
          [
            "bg-transparent",
            "border-none",
            "cursor-pointer",
            "decoration-[var(--design-color-border-action-tertiary-default)]",
            "p-0",
            "text-[var(--design-color-text-action-tertiary-default)]",
            "underline",
            "active:decoration-[var(--design-color-border-action-tertiary-hover)]",
            "active:text-[var(--design-color-text-action-tertiary-hover)]",
            "disabled:decoration-[var(--design-color-border-action-tertiary-disabled)]",
            "disabled:text-[var(--design-color-text-action-tertiary-disabled)]",
            "hover:decoration-[var(--design-color-border-action-tertiary-hover)]",
            "hover:text-[var(--design-color-text-action-tertiary-hover)]"
          ],
          className
        )
      }
      type={type} // eslint-disable-line react/button-has-type
    >
      {children}
    </button>
  );
}
